<template >
  <div class="classDialog">
    <el-dialog
      :title="title"
      :visible.sync="classDialogVisible"
      width="500px"
      :close-on-click-modal="false"
    >
      <el-form
        ref="classForm"
        :model="classForm"
        label-width="140px"
        :rules="rules"
      >
        <el-form-item
          v-if="this.$props.dialogType === 'add'"
          label="字段名"
          class="is-required"
          prop="name"
        >
          <el-input
            v-model.trim="classForm.name"
            maxlength="32"
            placeholder="请输入字段名"
          >
          </el-input>
        </el-form-item>
        <el-form-item
          label="排序值"
          class="is-required"
          prop="ordinal"
        >
          <el-input
            v-model.trim="classForm.ordinal"
            placeholder="请输入排序值..."
            maxlength="9"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="classDialogVisible = false">关闭</el-button>
        <el-button type="primary" @click="save()">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script type="text/babel">
const nameMap = {
  'column': '栏目',
  'type': '类型'
}

const typeMap = {
  'add': '新增',
  'edit': '编辑'
}

export default {
  props: {
    dialogName: {
      type: String,
      default: 'column'
    },
    dialogType: {
      type: String,
      default: 'add'
    },
    id: Number,
    stageId: Number,
    typeId: Number,
    name: String,
    value: {
      type: Boolean,
      default () {
        return false
      }
    },
    rowData: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      classForm: {
        id: '',
        stageId: '',
        name: '',
        ordinal: '',
        typeId: ''
      },
      rules: {
        name: [
          {
            required: true,
            message: `请输入名称`,
            trigger: ['blur', 'change']
          }
        ]
      }
    }
  },
  methods: {
    save () {
      this.$refs.classForm.validate(async valid => {
        if (valid) {
          this.$emit('success', this.classForm)
        }
      })
    }
  },
  watch: {
    classDialogVisible (newVal, oldVal) {
      if (newVal) {
        if (this.$refs.classForm) {
          Object.keys(this.classForm).forEach(key => this.classForm[key] = '');
          this.$refs.classForm.resetFields();
        }
        // 加载初始化数据
        if (this.$props.dialogType === 'edit') {
          this.classForm = {
            ...this.$props.rowData
          }
        } else {
          this.classForm = {
            ...this.$props.rowData,
            typeId: this.$props.typeId || '',
            stageId: this.$props.stageId || ''
          }
        }
      }
    }
  },
  computed: {
    title() {
      return `${typeMap[this.$props.dialogType]}${nameMap[this.$props.dialogName]}`;
    },
    classDialogVisible: {
      get () {
        return this.value;
      },
      set (val) {
        this.$emit('input', val);
      }
    }
  },
  mounted () {
    if (this.$props.dialogType === 'edit') {
      this.rules = {}
    }
    else {
      this.rules = {
        name: [
          {
            required: true,
            message: `请输入名称`,
            trigger: ['blur', 'change']
          }
        ]
      }
    }
  },
}
</script>
<style scoped>
  .classDialog .el-input{
    width:80%;
  }
</style>
<style type="text/css">

</style>



// WEBPACK FOOTER //
// src/pages/layout/common-manage/edit-dialog/index.vue